import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1324eb52&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../static/oa-img/css/step-complete.css?vue&type=style&index=0&id=1324eb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324eb52",
  null
  
)

export default component.exports